<template>
  <div
    class="msg-market"
    :class="{
      'normal-over': shouldExpand,
      expand: expand
    }"
  >
    <div class="msg-market-name">
      {{ marketName }}
    </div>

    <div
      v-if="isSpecifiers"
      class="msg-market-specifier"
    >
      <MsgMarketItem
        :outcome-size="marketInfo.outcomeNumber"
        :market-id="marketId"
        :market="market"
        :market-titles="marketTitles"
        :event="event"
        show-outcome-desc
        :outcome-descriptions="marketTitles"
        @selectVisible="onSelectVisible"
      />
    </div>

    <template v-else>
      <Market5Normal
        :event="event"
        :market="market"
      />

      <div
        v-if="shouldExpand"
        class="msg-market-mask"
        :class="{
          expand
        }"
        @click="toggleExpand"
      >
        <svg-icon icon-class="icon-expand-double" />
      </div>
    </template>
  </div>
</template>

<script>
import { storeToRefs } from 'pinia'
import { useMatchDetailStore } from 'wap/stores/matchDetail'
import useDefaultMarket from 'composables/market/useDefaultMarket.js'
import MsgMarketItem from './MsgMarketItem/Market.vue'
import Market5Normal from '../../components/Market5Normal'
import 'base/icons/svg/expand-double.svg'

export default {
  name: 'MsgMarket',
  components: {
    MsgMarketItem,
    Market5Normal
  },
  props: {
    marketId: {
      type: [Number, String],
      default: undefined
    },
    market: {
      type: [Object, Array],
      default: () => ({})
    },
    marketName: {
      type: String,
      default: ''
    }
  },
  setup() {
    const matchDetailStore = useMatchDetailStore()
    const { event, subedMarketIds } = storeToRefs(matchDetailStore)

    const { marketsMap } = useDefaultMarket()

    const { subMarkets } = matchDetailStore

    return {
      event,
      marketsMap,
      subedMarketIds,
      subMarkets
    }
  },
  data() {
    return {
      // 展开状态
      expand: false
    }
  },
  computed: {
    isSpecifiers() {
      return Array.isArray(this.market)
    },
    shouldExpand() {
      if (this.isSpecifiers) return
      const { outcomes } = this.market
      return outcomes && outcomes.order.length > 3
    },
    marketInfo() {
      console.log(this.marketId)
      return this.marketsMap[+this.marketId] || {}
    },
    marketTitles() {
      return this.marketInfo.title || []
    }
  },
  mounted() {
    this.sub(true)
  },
  beforeDestroy() {
    this.sub(false)
  },
  methods: {
    sub(isSub = true) {
      const { marketId } = this
      if (!this.subedMarketIds[marketId]) {
        this.subMarkets({ marketId, isSub })
      }
    },
    toggleExpand() {
      this.expand = !this.expand
    },
    onSelectVisible(visible) {
      this.$emit('selectVisible', visible)
    }
  }
}
</script>

<style lang="less">
@import url("../../style/market.less");

.msg-market {
  padding: 10px;
  border-radius: 4px;
  background: #333;

  &.normal-over {
    position: relative;

    .m-market-normal {
      overflow: hidden;
      max-height: 82px;
    }
  }

  &.expand {
    padding-bottom: 30px;

    .m-market-normal {
      overflow: initial;
      max-height: initial;
    }
  }

  .msg-market-name {
    width: 100%;
    margin-bottom: 7px;
    color: #fff;
    font-size: 14px;
    line-height: 16px;
  }

  .m-specifier {
    height: 36px;
    margin-right: 4/@rem;
    line-height: 1;

    .v-select-wrap {
      line-height: 36px;

      &.active {
        line-height: 35px;
      }
    }
  }

  .m-outcome {
    width: 33.3%;
    height: 36px;
    box-sizing: border-box;
    background: #555;

    &.active {
      background: @primary;
    }
  }

  .msg-market-specifier {
    flex: none;
  }

  .msg-market-mask {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 42px;
    background-image: linear-gradient(180deg, fade(#000, 0%), fade(#000, 90%));
    text-align: center;

    &.expand {
      height: 30px;
      background: none;

      .svg-icon {
        bottom: 10px;
        transform: translateX(-50%) rotate(180deg);
      }
    }

    .svg-icon {
      position: absolute;
      bottom: 0;
      left: 50%;
      color: #fff;
      font-size: 12px;
      transform: translateX(-50%);
    }
  }
}

.v-select-scroll {
  top: 36px;
}
</style>
